module.exports = __webpack_public_path__ + "static/media/AOB-app_2screen.2348aba0.png";